import { render, staticRenderFns } from "./transactionComplainList.vue?vue&type=template&id=050d1258"
import script from "./transactionComplainList.vue?vue&type=script&lang=js"
export * from "./transactionComplainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports